import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { shortcut } from './menu-v2.css.js';

/** MenuV2.Shortcut */
const Shortcut = forwardRef(({ children }, ref) => {
    return (jsx("span", { ref: ref, className: shortcut, children: children }));
});
Shortcut.displayName = 'MenuV2.Shortcut';

export { Shortcut };
//# sourceMappingURL=menu-v2.shortcut.js.map
